// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"98b28dec","498":"08cdb8a7","703":"bce539a8","787":"df266905"}[chunkId] + ".chunk.js";
};